import { render, staticRenderFns } from "./TableTreeColumn.vue?vue&type=template&id=24a4acdb&"
import script from "./TableTreeColumn.vue?vue&type=script&lang=js&"
export * from "./TableTreeColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports